module.exports = __webpack_public_path__ + "b24a98b3adc161607bd52819297b5dd8.gltf";